import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        appointment: {
            backgroundColor: theme.appointmentBackgroundColor,
            color: theme.appointmentBackgroundColor,
        },
        container: {
            ...theme.fonts.default,
            backgroundColor: theme.calendarBackgroundColor,
            color: theme.calendarTextColor,
        },
        switcher: {
            ...theme.fonts.default,
        },
    };
};

export default getTheme;
